import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Compare as CompareComponent } from '@/components/Compare';
import { useComparisonContext } from '@/contexts/ComparisonContext';
import { SEOHead } from '@/components/SEOHead';

const ComparePage = () => {
  const navigate = useNavigate();
  const { comparisonList, removeFromComparison, clearComparison } = useComparisonContext();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Compare AI Tools Side-by-Side — Features & Pricing | Vergo"
        description="Compare AI tools side-by-side on features, pricing, model quality, and use cases. Make a confident choice with Vergo's interactive comparison tool."
        keywords="compare AI tools, AI tool comparison, ChatGPT vs Claude, AI side by side, AI feature comparison, AI pricing comparison"
      />
      {/* Header */}
      <header className="border-b border-border bg-background/95 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/')}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-5 h-5" />
                <span>Back to Home</span>
              </Button>
            </div>
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-bold text-foreground">
                Vergo
              </h1>
            </div>
          </div>
        </div>
      </header>

      {/* Compare Component */}
      <main>
        <CompareComponent
        comparisonList={comparisonList}
        onRemoveFromComparison={removeFromComparison}
        onClearComparison={clearComparison}
      />
      </main>
    </div>
  );
};

export default ComparePage;